import React from "react";
import { useDropzone } from "react-dropzone";
import { useState, useCallback, useEffect } from "react";

import { imageUploaderContainer, previewImage, imageUploaderText, imageUploaderContainerSpecial } from "./image-uploader.module.scss";

const activeStyle: React.CSSProperties = {
  borderColor: "#CF60C8",
};


interface IImageUploaderProps {
    imageUrl?: string;
    isSpecial?: boolean;
    onUploadPhoto?(file:File): void;
}


const ImageUploader: React.FC<IImageUploaderProps> = ({
  imageUrl = "",
  isSpecial = false,
  onUploadPhoto
}) => {
  const [preview, setPreview] = useState<string | null>(null);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);
      if (onUploadPhoto) {
        onUploadPhoto(file);
      }
    }
  }, [onUploadPhoto]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });

  const style = {
    ...(isDragActive ? activeStyle : {}),
  };
  // zwolnij URL po odmontowaniu komponentu
  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  useEffect(() => {
    if (imageUrl && imageUrl !== "") {
      setPreview(imageUrl);
    }
  }, []);
  useEffect(() => {
    if (imageUrl && imageUrl !== "") {
      setPreview(imageUrl);
    }
  }, [imageUrl]);

  return (
    <div {...getRootProps()} className={isSpecial ? `${imageUploaderContainerSpecial} ${imageUploaderContainer}` : imageUploaderContainer} style={style}>
      <input {...getInputProps()} />
      {preview ? (
        <img className={previewImage} src={preview} alt="Podgląd zdjęcia profilowego" />
      ) : (
        <p className={imageUploaderText}>
          {isDragActive ? "Upuść plik tutaj..." : "Przeciągnij lub kliknij, aby wgrać swoje zdjęcie"}
        </p>
      )}
    </div>
  );
}
export default ImageUploader;
